import {ITableColumn} from '../../../types';
import {ReactNode} from 'react';

export type SubscriptionDimension = { name: string, value: string }

export type Price = {
    id: string,
    productId: string,
    amount: number,
    billingPeriod: string,
    currency?: string
}

export type Product = {
    id: string,
    name: string,
    shortDescription?: string,
    longDescription?: string,
    status?: string,
    freeTrial?: boolean,
    baseFee?: number,
    prices?: {
        items: Price[],
        nextToken?: string
    },
    lineItems?: {
        items: {
            productFeature: {
                name: string,
                description: string
            }
        }[],
        nextToken?: string
    }
}

export type SubscriptionItem = {
    id: string,
    priceId: string,
    price: {
        product: { id: string, name: string }
        amount: number
        billingPeriod: string
    }
    quantity: number
}

export type SubscriptionItems = { items: SubscriptionItem[], nextToken: string }

export enum CustomerSubscriptionStatus {
    Active = 'Active',
    Inactive = 'Inactive'
}

// Alias for backward compatibility - re-export the enum
export { CustomerSubscriptionStatus as SubscriptionStatus };

export type CustomerSubscription = {
    id: string,
    customerId: string,
    customer: { 
        id: string, 
        name: string
    },
    items: SubscriptionItems,
    status: CustomerSubscriptionStatus
    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    managedByUsername?: string
    managedBy?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,
}

// Alias for backward compatibility
export type Subscription = CustomerSubscription;


export interface ISubscriptionTableColumn extends ITableColumn {
    render?: (item: Subscription) => ReactNode;
}

export type ListSubscriptions = {
    listCustomerSubscriptionsForCustomer: { items: CustomerSubscription[], nextToken: string }
}

export type GetSubscription = {
    getCustomerSubscription: CustomerSubscription
}

export type CreateSubscription = {
    createCustomerSubscription: CustomerSubscription
}

export type UpdateSubscription = {
    updateCustomerSubscription: CustomerSubscription
}

export type DeleteSubscription = {
    deleteCustomerSubscription: string
}

export type ListProducts = {
    listProducts: { items: Product[], nextToken: string }
}

export type GetProduct = {
    getProduct: Product
}




